import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAvatarIcon, LazyEmptyState, LazyExtendedWysiwyg, LazyGlobalIcon, LazyInputWithDropdown, LazySideScroll, LazySimpleSelect, LazySimpleSwiper, LazyColorSwatch, LazyDebugOutput, LazyGenericAccordion, LazyLoadProgress, LazyLoadingIcon, LazyReadMore, LazyTableContent, LazyAccordionBlock, LazyAccordionTab, LazyAccordionTabBlock, LazyArticlePage, LazyBookAppointmentBlock, LazyBrandListBlock, LazyBrandListingPage, LazyBrandPage, LazyButton, LazyCategoryListingBlock, LazyCategoryVisualListingBlock, LazyCheckoutPage, LazyCheckoutResult, LazyCodeSnippet, LazyConfig, LazyCoverBlock, LazyCustomerServiceBlock, LazyEditorialProductBlock, LazyErrorPage, LazyEventBlock, LazyEventEntry, LazyFindRetailerBlock, LazyFloorPlannerBlock, LazyFloorPlannerIframe, LazyFormBlock, LazyGlobalFooter, LazyHeaderData, LazyHotSpotBlock, LazyIconBoxBlock, LazyIconListBlock, LazyImageBlock, LazyImageGalleryBlock, LazyMarqueeBannerBlock, LazyMarqueeVisualBannerBlock, LazyModalVideoPlayerBlock, LazyMultiColumnBlock, LazyNestableNav, LazyNestableNavFooter, LazyNewsletterSignup, LazyPage, LazyProductFilterFunnel, LazyProductFilterSettings, LazyProductListWithImage, LazyProductPage, LazyQuoteBlock, LazyQuoteBlockRandom, LazySalesToolsSettings, LazySectionHeading, LazySiteNoticeSettings, LazyStatisticsBlock, LazySwatchSwitcherBlock, LazyTab, LazyTabBlock, LazyTextImageVideoBlock, LazyTextPromoBlock, LazyTypeFormBlock, LazyVideoPlayer, LazyWysiwyg, LazyArticleKeyword, LazyArticleListing, LazyArticleListingCard, LazyBylineBlock, LazyEmployeeCard, LazyEmployeeCardGroup, LazyEmployeeListing, LazyEmployeeTab, LazyFeatureList, LazyPromoBlock, LazyPromoGrid, LazyTableBlock } from '#components'
const lazyGlobalComponents = [
  ["AvatarIcon", LazyAvatarIcon],
["EmptyState", LazyEmptyState],
["ExtendedWysiwyg", LazyExtendedWysiwyg],
["GlobalIcon", LazyGlobalIcon],
["InputWithDropdown", LazyInputWithDropdown],
["SideScroll", LazySideScroll],
["SimpleSelect", LazySimpleSelect],
["SimpleSwiper", LazySimpleSwiper],
["ColorSwatch", LazyColorSwatch],
["DebugOutput", LazyDebugOutput],
["GenericAccordion", LazyGenericAccordion],
["LoadProgress", LazyLoadProgress],
["LoadingIcon", LazyLoadingIcon],
["ReadMore", LazyReadMore],
["TableContent", LazyTableContent],
["AccordionBlock", LazyAccordionBlock],
["AccordionTab", LazyAccordionTab],
["AccordionTabBlock", LazyAccordionTabBlock],
["ArticlePage", LazyArticlePage],
["BookAppointmentBlock", LazyBookAppointmentBlock],
["BrandListBlock", LazyBrandListBlock],
["BrandListingPage", LazyBrandListingPage],
["BrandPage", LazyBrandPage],
["Button", LazyButton],
["CategoryListingBlock", LazyCategoryListingBlock],
["CategoryVisualListingBlock", LazyCategoryVisualListingBlock],
["CheckoutPage", LazyCheckoutPage],
["CheckoutResult", LazyCheckoutResult],
["CodeSnippet", LazyCodeSnippet],
["Config", LazyConfig],
["CoverBlock", LazyCoverBlock],
["CustomerServiceBlock", LazyCustomerServiceBlock],
["EditorialProductBlock", LazyEditorialProductBlock],
["ErrorPage", LazyErrorPage],
["EventBlock", LazyEventBlock],
["EventEntry", LazyEventEntry],
["FindRetailerBlock", LazyFindRetailerBlock],
["FloorPlannerBlock", LazyFloorPlannerBlock],
["FloorPlannerIframe", LazyFloorPlannerIframe],
["FormBlock", LazyFormBlock],
["GlobalFooter", LazyGlobalFooter],
["HeaderData", LazyHeaderData],
["HotSpotBlock", LazyHotSpotBlock],
["IconBoxBlock", LazyIconBoxBlock],
["IconListBlock", LazyIconListBlock],
["ImageBlock", LazyImageBlock],
["ImageGalleryBlock", LazyImageGalleryBlock],
["MarqueeBannerBlock", LazyMarqueeBannerBlock],
["MarqueeVisualBannerBlock", LazyMarqueeVisualBannerBlock],
["ModalVideoPlayerBlock", LazyModalVideoPlayerBlock],
["MultiColumnBlock", LazyMultiColumnBlock],
["NestableNav", LazyNestableNav],
["NestableNavFooter", LazyNestableNavFooter],
["NewsletterSignup", LazyNewsletterSignup],
["Page", LazyPage],
["ProductFilterFunnel", LazyProductFilterFunnel],
["ProductFilterSettings", LazyProductFilterSettings],
["ProductListWithImage", LazyProductListWithImage],
["ProductPage", LazyProductPage],
["QuoteBlock", LazyQuoteBlock],
["QuoteBlockRandom", LazyQuoteBlockRandom],
["SalesToolsSettings", LazySalesToolsSettings],
["SectionHeading", LazySectionHeading],
["SiteNoticeSettings", LazySiteNoticeSettings],
["StatisticsBlock", LazyStatisticsBlock],
["SwatchSwitcherBlock", LazySwatchSwitcherBlock],
["Tab", LazyTab],
["TabBlock", LazyTabBlock],
["TextImageVideoBlock", LazyTextImageVideoBlock],
["TextPromoBlock", LazyTextPromoBlock],
["TypeFormBlock", LazyTypeFormBlock],
["VideoPlayer", LazyVideoPlayer],
["Wysiwyg", LazyWysiwyg],
["ArticleKeyword", LazyArticleKeyword],
["ArticleListing", LazyArticleListing],
["ArticleListingCard", LazyArticleListingCard],
["BylineBlock", LazyBylineBlock],
["EmployeeCard", LazyEmployeeCard],
["EmployeeCardGroup", LazyEmployeeCardGroup],
["EmployeeListing", LazyEmployeeListing],
["EmployeeTab", LazyEmployeeTab],
["FeatureList", LazyFeatureList],
["PromoBlock", LazyPromoBlock],
["PromoGrid", LazyPromoGrid],
["TableBlock", LazyTableBlock],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
